var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-1 flex flex-col",class:{
    'border-l border-gray-500': !_vm.meta.isFirstDayOfWeek,
    'bg-gray-400': _vm.meta.isFocusedDay,
    'bg-gray-200': _vm.meta.isDiffMonth,
  },on:{"click":function($event){return _vm.$emit('set-date', _vm.day)}}},[_c('div',{staticClass:"flex text-xs bg-smoke-100 px-1"},[(_vm.meta.isFirstDayOfWeek)?_c('span',{staticClass:"text-gray-700"},[_vm._v(_vm._s(_vm.week)+" ")]):_vm._e(),_c('span',{staticClass:"ml-auto"},[_vm._v(_vm._s(_vm.day.date()))])]),_c('div',{staticClass:"flex-1 min-h-48"},[_c('div',{staticClass:"p-1 text-xs cursor-default space-y-1"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }